module.exports = __webpack_public_path__ + "img/tx.ab179ec7.png";